// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
    },
    containerImage: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    image: {
      width: 40,
      height: 40,
    },
    message: {
      marginTop: 10,
      textAlign: 'center',
    },
    containerButtons: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1),
    },
    title: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      marginBottom: theme.spacing(2),
    },
  }),
);

export default useStyles;
